import type { ComponentPropsWithRef } from 'react';

import { clsx } from '~/styles/utils';

import { StepperContext } from './Stepper.context';
import { rootStyle } from './Stepper.css';

type Props = ComponentPropsWithRef<'ol'> & {
  'aria-label': string;
  currentStep: number;
};

export const StepperRoot = ({ children, currentStep, ...delegated }: Props) => {
  return (
    <StepperContext value={{ currentStep }}>
      <ol {...delegated} className={clsx(rootStyle, delegated.className)}>
        {children}
      </ol>
    </StepperContext>
  );
};
